import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal } from "./Reveal";
import { useLang } from "../../lib/i18n";

export const Faq = () => {
  const { t } = useLang();
  return (
  <section id="faq" data-testid="faq-section" className="py-24 sm:py-36 border-t hairline">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-4">
        <p className="eyebrow mb-5">{t("faq.eyebrow")}</p>
        <h2 className="font-display font-bold tracking-[-0.03em] text-5xl sm:text-6xl">{t("faq.pre")}<span className="font-serif-i font-normal text-[var(--husk)]">{t("faq.accent")}</span></h2>
      </div>
      <Reveal className="lg:col-span-8">
        <Accordion type="single" collapsible>
          {t("faq.qa").map(([q, a], i) => (
            <AccordionItem key={i} value={`q${i}`} className="border-b hairline">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-display text-xl sm:text-2xl text-left py-6 hover:no-underline">{q}</AccordionTrigger>
              <AccordionContent className="text-[var(--sage)] text-base leading-relaxed pb-6">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
  );
};
